<!-- src/app/pages/report-card/report-card.html -->
<section class="delegation-page">

  <!-- HERO -->
  <div class="delegation-hero">
    <div class="delegation-eyebrow">Accountability Tool</div>
    <h1>Know Your Michigan Delegation</h1>
    <p>
      Meet Michigan's full congressional delegation - 2 senators and 13 representatives
      serving in the 119th Congress. Click any member to view their full voting record
      on Congress.gov.
    </p>
  </div>

  <!-- RESOURCE LINKS -->
  <div class="delegation-resources">
    <div class="container">
      <div class="delegation-resources__label">Independent Voting Scorecards</div>
      <div class="delegation-resources__links">
        <a href="https://www.aclu.org/congressional-scorecards" target="_blank" rel="noopener noreferrer">ACLU Civil Liberties Scorecard</a>
        <a href="https://scorecard.lcv.org" target="_blank" rel="noopener noreferrer">League of Conservation Voters</a>
        <a href="https://www.hrc.org/resources/congressional-scorecard" target="_blank" rel="noopener noreferrer">Human Rights Campaign</a>
        <a href="https://aflcio.org/scorecard" target="_blank" rel="noopener noreferrer">AFL-CIO Labor Scorecard</a>
      </div>
    </div>
  </div>

  <!-- BODY -->
  <div class="delegation-body">
    <div class="container">

      <div *ngIf="isLoading" class="delegation-loading">
        <div class="delegation-loading__spinner"></div>
        <p>Loading delegation...</p>
      </div>

      <!-- SENATE -->
      <div *ngIf="!isLoading">
        <h2 class="delegation-section-title">
          <span class="delegation-section-title__icon">🏛</span>
          United States Senate
        </h2>
        <div class="delegation-grid">
          <a
            class="member-card"
            *ngFor="let member of senators"
            [href]="member.url"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div class="member-card__photo">
              <img
                [src]="member.imageUrl"
                [alt]="member.name"
                loading="lazy"
                (error)="onImgError($event)"
              />
            </div>
            <div class="member-card__info">
              <div class="member-card__name">{{ member.name }}</div>
              <div class="member-card__district">{{ member.district }}</div>
              <div class="member-card__party"
                [class.party-d]="member.party === 'Democratic'"
                [class.party-r]="member.party === 'Republican'"
                [class.party-i]="member.party === 'Independent'"
              >{{ member.party }}</div>
            </div>
            <div class="member-card__cta">View Record →</div>
          </a>
        </div>

        <!-- HOUSE -->
        <h2 class="delegation-section-title">
          <span class="delegation-section-title__icon">🏠</span>
          United States House of Representatives
        </h2>
        <div class="delegation-grid delegation-grid--house">
          <a
            class="member-card"
            *ngFor="let member of representatives"
            [href]="member.url"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div class="member-card__photo">
              <img
                [src]="member.imageUrl"
                [alt]="member.name"
                loading="lazy"
                (error)="onImgError($event)"
              />
            </div>
            <div class="member-card__info">
              <div class="member-card__name">{{ member.name }}</div>
              <div class="member-card__district">{{ member.district }}</div>
              <div class="member-card__party"
                [class.party-d]="member.party === 'Democratic'"
                [class.party-r]="member.party === 'Republican'"
                [class.party-i]="member.party === 'Independent'"
              >{{ member.party }}</div>
            </div>
            <div class="member-card__cta">View Record →</div>
          </a>
        </div>
      </div>

    </div>
  </div>

  <!-- PLEDGE -->
  <div class="delegation-pledge">
    <div class="container">
      <h2>Lydia's Pledge</h2>
      <p>
        When elected, Lydia will publish plain-English explanations of every vote she casts
        within 48 hours - so Michigan voters always know where she stands and why.
        No spin. Full transparency.
      </p>
      <a routerLink="/volunteer" class="delegation-pledge__btn">Help Get Lydia Elected</a>
    </div>
  </div>

</section>
